// Utils
import SmoothScrolling from '../../utils/smooth-scrolling'
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'app-menu-restaurants',

    data()
    {
        return {
            menuWrapperWidth: 0,
            scrollX: 0,
            menuWrapperTranslateXMax: 0
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.menu.acf
        },

        restaurants()
        {
            const restaurants = this.$root.contentPage.restaurants
            const _restaurants = []

            for (let i = 0; i < restaurants.length; i += 1)
            {
                const _restaurant = restaurants[i]
                const index = i > 7 ? i + 1 - (Math.floor(i / 8) * 8) : i + 1

                if (index % 8 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.HORIZONTAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.TOP
                }
                else if (index % 7 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.HORIZONTAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.BOTTOM
                }
                else if (index % 6 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.VERTICAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.TOP
                }
                else if (index % 5 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.HORIZONTAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.BOTTOM
                }
                else if (index % 4 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.VERTICAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.TOP
                }
                else if (index % 3 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.HORIZONTAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.TOP
                }
                else if (index % 2 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.HORIZONTAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.BOTTOM
                }
                else if (index % 1 === 0)
                {
                    _restaurant.menu_layout = this.$root.CONSTANTS.menuLayouts.VERTICAL
                    _restaurant.menu_layout_text = this.$root.CONSTANTS.menuLayouts.TOP
                }

                _restaurants.push(_restaurant)
            }

            return _restaurants
        },

        menuIsOpen()
        {
            return this.$root.menuIsOpen
        }
    },

    watch:
    {
        menuIsOpen: 'onMenuIsOpenChange'
    },

    created()
    {
        // Events
        this.eventHub.$on('keyboard:keydown', this._onKeydown)
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('mouse:move', this._onMousemove)
        this.eventHub.$on('window:raf', this._onEnterFrame)

        // Variables
        this.scrollSpeedX = 0
        this.restaurantDivWidth = 0
        this._overlayCloseTextOffsets =
        {
            x: 10,
            y: 10
        }

        this._mouse =
        {
            x: 0,
            y: 0,
            event:
            {
                x: 0,
                y: 0
            }
        }

        this._overlayCloseRect = null
    },

    mounted()
    {
        this.$menuWrapper = this.$el.querySelector('.js-menu-wrapper')
        this.$overlayClose = this.$el.querySelector('.js-overlay-close')
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('keyboard:keydown', this._onKeydown)
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('mouse:move', this._onMousemove)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods:
    {
        // Watchers
        onMenuIsOpenChange()
        {
            this._scroll.canStart = this.menuIsOpen
        },

        // Events
        _onKeydown(event)
        {
            if (this.menuIsOpen
                && event.keyCode === 27)
            {
                this._closeMenu()
            }
        },

        _onMousemove(mouse)
        {
            this._mouse.event.x = mouse.x + this._overlayCloseTextOffsets.x
            this._mouse.event.y = mouse.y + this._overlayCloseTextOffsets.y
        },

        _onEnterFrame()
        {
            this._mouse.x += (this._mouse.event.x - this._mouse.x) * 0.1
            this._mouse.x = Math.round(this._mouse.x * 100) / 100

            this._mouse.y += (this._mouse.event.y - this._mouse.y) * 0.1
            this._mouse.y = Math.round(this._mouse.y * 100) / 100

            if (this.$overlayClose
                && this.menuIsOpen)
            {
                const translateX = Math.min(this._mouse.x, this.$root.width - this._overlayCloseRect.width)
                const translateY = Math.min(this._mouse.y, this.$root.height - this._overlayCloseRect.height)
                this.$overlayClose.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(0)`
            }
        },

        _onResize()
        {
            let restaurantDivWidth = 260
            let restaurantDivMarginRight = 160
            if (this.$root.width <= this.$root.CONSTANTS.breakpoints.xxs)
            {
                restaurantDivWidth = 150
                restaurantDivMarginRight = 80
            }
            this.restaurantOffsetWidth = restaurantDivWidth + restaurantDivMarginRight

            this.menuWrapperWidth = ((this.restaurants.length * restaurantDivWidth) + ((this.restaurants.length - 1) * restaurantDivMarginRight) + (Math.min(this.$root.width / 10 * 2, this.$root.CONSTANTS.breakpoints.design / 10 * 2)))

            this.menuWrapperTranslateXMax = this.menuWrapperWidth - this.$root.width

            if (this.$menuWrapper)
            {
                this._scroll = new SmoothScrolling(
                    {
                        section: this.$menuWrapper,
                        sectionWidth: this.menuWrapperWidth - this.$root.width,
                        sectionLimit: this.menuWrapperTranslateXMax * -1,
                        onTick: this._onScroll,
                        canStart: false,
                        events:
                        [
                            'keyboard',
                            'drag',
                            'vertical-scroll',
                            'horizontal-scroll'
                        ]
                    }
                )

                this._scroll.init()
            }

            if (this.$overlayClose)
            {
                this._overlayCloseRect = getAbsoluteBoundingRect(this.$overlayClose)
            }
        },

        _onScroll(gesture)
        {
            this.scrollSpeedX = gesture.speed.x
            this.scrollX = gesture.position.x * -1

            if (this.menuIsOpen
                && this._scroll.initialized)
            {
                // do something
            }
        },

        // HTML Actions
        _onClickOnOverlay()
        {
            this._closeMenu()
        },

        _onClickOnPrevious()
        {
            if (this._scroll.initialized
                && this.scrollX > 50)
            {
                this._scroll.scrollTo(this.scrollX - this.restaurantOffsetWidth, true)
            }
        },

        _onClickOnNext()
        {
            if (this._scroll.initialized
                && this.scrollX < this.menuWrapperTranslateXMax - 50)
            {
                this._scroll.scrollTo(this.scrollX + this.restaurantOffsetWidth, true)
            }
        },

        _onClickOnRestaurant(slug)
        {
            if (Math.abs(this.scrollSpeedX) <= 0.1)
            {
                this.$router.push(this.$root.getRestaurantURLFromSlug(slug))
            }
        },

        // Actions
        _closeMenu()
        {
            this.eventHub.$emit('menu:close')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-menu-restaurants/script.js